import Vue from "vue";
import mixins from "./mixins/definition.js";

//import OrganismsCommonHeader from "./components/organisms/common/Header.vue";
//import OrganismsCommonFooter from "./components/organisms/common/Footer.vue";
//import CrlyLogin from "@crly/views/Login.vue";

// export default {
//   set() {
//     Vue.component("OrganismsCommonHeader", OrganismsCommonHeader);
//     Vue.component("OrganismsCommonFooter", OrganismsCommonFooter);
//   }
// };

//Vue.component("OrganismsCommonHeader", OrganismsCommonHeader);
//Vue.component("OrganismsCommonFooter", OrganismsCommonFooter);
//Vue.component("CrlyLogin", CrlyLogin);

mixins.set();
